export const emailRegex = /^\S+@\S+$/;
